export default "__VITE_PUBLIC_ASSET__f1c9bb75__"